import {createSlice} from '@reduxjs/toolkit';
import {AGENCY_TIE_RULE, RTE_TIE_LOGIC_BLOCK} from '../../../../constants/Lookup';
import {httpGet, httpPost} from '../../../../util/Rest';

const initialData = {
  advanceSearchData: {},
  TyingRestrictionsData: {},
  dropDownData: {},
  TyingRestrictionsStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'TyingRestriction',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    fetchTyingRestrictionsData: (state, action) => {
      state.TyingRestrictionsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postTyingRestrictionsData: (state, action) => {
      state.TyingRestrictionsStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetTyingRestrictions: (state) => {
      state.TyingRestrictionsStatus = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchDropDownData, fetchError, fetchTyingRestrictionsData, postTyingRestrictionsData, resetMsg, resetTyingRestrictions} = slice.actions;

export const fetchTyingRestrictions = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/typingrestrictions/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchTyingRestrictionsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postTyingRestrictions = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`maintenance/save/typingrestrictions`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postTyingRestrictionsData(data));
          dispatch(fetchTyingRestrictions(details.clientNumber));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetTyingRestrictions());
  };
};

export const fetchDropdown = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [RTE_TIE_LOGIC_BLOCK, AGENCY_TIE_RULE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
